import React from "react";
// ANT DESIGN COMPONENT
import { Tag } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { faCodeBranch } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useSelector } from "react-redux";
// CONSTANTS
import { VERSION_DATE, VERSION_TAG } from "../../constants/login";
// COMPONENTS
import DrawerRowDivider from "../components/drawer/DrawerRowDivider";
// INTERFACES
import { RootState } from "../../app/store";

function LiftnetInformation() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getVersionTag = () => {
    if (process.env.REACT_APP_VERSION) {
      if (process.env.REACT_APP_VERSION?.trim() === "v2") {
        return <Tag color="blue">{VERSION_TAG}</Tag>;
      }
      if (process.env.REACT_APP_VERSION?.trim() === "v1") {
        return <Tag color="blue">{VERSION_TAG}</Tag>;
      }
    }
    return <Tag color="blue">UNKNOWN</Tag>;
  };

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      <br />
      {/** ************************************************* */}
      {/** COMPONENT DRAWER DIVIDER */}
      <DrawerRowDivider icon={faCodeBranch} title={t("general.version")} />
      {/** ************************************************* */}
      <div className={`drawer__box__${theme}`}>
        {/* -*-*-*-*-*-*-*-*-*-*-*-*-*-*- */}
        <div className="generalStyles__flex">
          <div>
            <p className="drawer__title">Version:</p>
          </div>
          <div className="drawer__textContainer">
            <p className="drawer__text">{getVersionTag()}</p>
          </div>
        </div>
        {/* -*-*-*-*-*-*-*-*-*-*-*-*-*-*- */}
        <div className="generalStyles__flex">
          <div>
            <p className="drawer__title">{t("general.date")}:</p>
          </div>
          <div className="drawer__textContainer">
            <p className="drawer__text">{VERSION_DATE}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiftnetInformation;
